import BRangeSlider from "./BRangeSlider";
import BRecipeList from "./BRecipeList";

const CHECKBOX_FILTER_NAMES = [
	"tagIds[]",
	"difficulties[]",
	"excludeAllergenIds[]",
	"canBeFrozen[]",
];

function collectCheckboxFilters(form) {
	const filters = {};

	for (const name of CHECKBOX_FILTER_NAMES) {
		const paramKey = name.replace("[]", "");
		const checked = form.querySelectorAll(`input[type="checkbox"][name="${name}"]:checked`);
		if (checked.length) {
			filters[paramKey] = Array.from(checked).map((el) => el.value);
		}
	}

	return filters;
}

function collectTriangleFilter(form) {
	const activePath = form.querySelector(".nutriangle-filter path.checked");
	if (!activePath) {
		return {};
	}

	return {
		macronutrients: {
			carbs: {
				min: activePath.dataset.carbsMin,
				max: activePath.dataset.carbsMax,
			},
			proteins: {
				min: activePath.dataset.proteinsMin,
				max: activePath.dataset.proteinsMax,
			},
			fats: {
				min: activePath.dataset.fatsMin,
				max: activePath.dataset.fatsMax,
			},
		},
	};
}

function applyFilters(form) {
	const list = form.closest("[data-list]") || form;
	const params = BRecipeList.getParams(list);

	for (const name of CHECKBOX_FILTER_NAMES) {
		const paramKey = name.replace("[]", "");
		delete params[paramKey];
	}
	delete params.macronutrients;

	Object.assign(params, collectCheckboxFilters(form));
	Object.assign(params, collectTriangleFilter(form));

	list.dataset.params = JSON.stringify(params);
	BRecipeList.reload(list);
}

function clearAllFilters(form) {
	const list = form.closest("[data-list]") || form;
	const params = BRecipeList.getParams(list);

	for (const name of CHECKBOX_FILTER_NAMES) {
		const paramKey = name.replace("[]", "");
		delete params[paramKey];
	}

	form.querySelectorAll("input[type=\"checkbox\"]:checked").forEach((cb) => {
		cb.checked = false;
	});

	const selectedTriangle = form.querySelector("input[name=\"makronutrienty\"]:checked");
	if (selectedTriangle) {
		selectedTriangle.checked = false;
	}
	form.querySelectorAll(".nutriangle-filter path.checked").forEach((p) => p.classList.remove("checked"));
	form.querySelectorAll(".nutriangle-filter").forEach((f) => hideTriangleMarker(f));
	delete params.macronutrients;

	BRangeSlider.resetAll(form);
	delete params.ranges;

	const queryInput = form.querySelector("input[name=\"query\"]");
	if (queryInput) {
		queryInput.value = "";
		BRecipeList.setQuery(list, "");
	}

	list.dataset.params = JSON.stringify(params);
	BRecipeList.reload(list);
}

function positionTriangleMarker(filter, path) {
	const marker = filter.querySelector(".check");
	if (!marker) {
		return;
	}

	const filterRect = filter.getBoundingClientRect();
	const pathRect = path.getBoundingClientRect();
	if (!filterRect.width || !pathRect.width) {
		return;
	}

	const isAlt = path.classList.contains("alt");

	const cx = isAlt
		? (pathRect.left - filterRect.left + pathRect.width / 1.75)
		: (pathRect.left - filterRect.left + pathRect.width / 2);
	const cy = isAlt
		? (pathRect.top - filterRect.top + pathRect.height / 4)
		: (pathRect.top - filterRect.top + pathRect.height / 2);

	marker.classList.remove("hidden");
	marker.style.left = (cx / filterRect.width * 100) + "%";
	marker.style.top = (cy / filterRect.height * 100) + "%";
}

function hideTriangleMarker(filter) {
	const marker = filter.querySelector(".check");
	if (marker) {
		marker.classList.add("hidden");
	}
}

function handleTriangleClick(form, clickedPath) {
	const wasChecked = clickedPath.classList.contains("checked");
	const filter = clickedPath.closest(".nutriangle-filter");

	form.querySelectorAll(".nutriangle-filter path.checked").forEach((p) => p.classList.remove("checked"));

	const selectedRadio = form.querySelector("input[name=\"makronutrienty\"]:checked");
	if (selectedRadio) {
		selectedRadio.checked = false;
	}

	if (!wasChecked) {
		clickedPath.classList.add("checked");
		const radioId = clickedPath.dataset.id;
		const radio = form.querySelector(`#${radioId}`);
		if (radio) {
			radio.checked = true;
		}
		positionTriangleMarker(filter, clickedPath);
	} else {
		hideTriangleMarker(filter);
	}

	applyFilters(form);
}

export default {
	initialize() {
		document.querySelectorAll(".rcp-filter").forEach((form) => {
			for (const name of CHECKBOX_FILTER_NAMES) {
				form.querySelectorAll(`input[type="checkbox"][name="${name}"]`).forEach((checkbox) => {
					checkbox.addEventListener("change", () => applyFilters(form));
				});
			}

			form.querySelectorAll(".nutriangle-filter path[data-id]").forEach((path) => {
				path.style.cursor = "pointer";
				path.addEventListener("click", () => handleTriangleClick(form, path));
			});

			form.querySelectorAll(".nutriangle-filter path.checked").forEach((path) => {
				const filter = path.closest(".nutriangle-filter");
				positionTriangleMarker(filter, path);
			});

			const cancelBtn = form.querySelector(".filtering .cancel");
			if (cancelBtn) {
				cancelBtn.addEventListener("click", (e) => {
					e.preventDefault();
					clearAllFilters(form);
				});
			}
		});
	},
};
